"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
exports.Type = prelude_1.t.strict({
    proposals: prelude_1.t.readonlyArray(prelude_1.t.strict({ text: prelude_1.t.string }))
});
//# sourceMappingURL=TextProposals.js.map